import { useEffect, useState } from 'react';
import React from 'react';
import './registro.css';
import { useTranslation } from "react-i18next";

import back_i from '../../../assets/imgs/libro_bitcoin/fondo-bitcoin-left-low.png';
import back_d from '../../../assets/imgs/libro_bitcoin/fondo-bitcoin-right-low.png';
import libros from '../../../assets/imgs/libro_bitcoin/libros-reg2.png';
import libros_2 from '../../../assets/imgs/libro_bitcoin/Bitcoin-books-32-low.png';
import bitcoin from '../../../assets/imgs/libro_bitcoin/log-bitcoin.png';
import play from '../../../assets/imgs/libro_bitcoin/btn_play_audio.svg';

import img4 from '../../../assets/imgs/libro_bitcoin/VGw-entrevista2-min1.jpg';
import img3 from '../../../assets/imgs/libro_bitcoin/video3-bit-low.jpg';
import img2 from '../../../assets/imgs/libro_bitcoin/poster-problemas2.jpg';
import img1 from '../../../assets/imgs/libro_bitcoin/poster-porque2.jpg';

import { useContext } from 'react';
import { PopupContext } from '../../../context/PopupContext';
import ModalVideo from "../../../components/modal/ModalVideo";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';


const Registro = () => {
    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("libroBitcoin");
    const { visible, setVisible } = useContext(PopupContext);
    const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
    const [urlVideo, setUrlVideo] = useState("");

    const openModalVideo = (contenido) => {
        setUrlVideo(contenido);
        setIsOpenModalVideo(true);
    };

    const closeModalVideo = () => {
        setUrlVideo("");
        setIsOpenModalVideo(false);
    };

    return (
        <>
            <div class="landing_bitcoin_registro">
                <div class="landing_bitcoin_registro_content">
                    <h4 dangerouslySetInnerHTML={{ __html: (t('registro.titulo')) }}></h4>
                    <div class="registro_content">
                        <div class="registro">
                            <img src={t('donde.btnaudio') === 'EN' ? libros : libros_2}></img>
                            <h3 dangerouslySetInnerHTML={{ __html: (t('registro.texto1')) }}>

                            </h3>
                            <h5 dangerouslySetInnerHTML={{ __html: (t('registro.texto2')) }}></h5>
                            <hr></hr>
                            <button onClick={() => { setVisible(true) }}>{(t('registro.btn1'))}</button>
                        </div>
                        <div class="audios">
                            <Swiper
                                direction="vertical"
                                slidesPerView={2}
                                slidesPerGroup={1}
                                spaceBetween={10}
                                loop={false}
                                allowTouchMove={false}
                                navigation={{
                                    nextEl: '.swiper-button-next-vertical',
                                    prevEl: '.swiper-button-prev-vertical',
                                }}
                                modules={[Navigation]}
                                className="slider-vertical"
                            >

                                <SwiperSlide>
                                    <div className="audios_card">
                                        <div className="audios_card_img">
                                            <img src={bitcoin} />
                                        </div>
                                        <div className="audios_card_content">
                                            <img
                                                onClick={() => openModalVideo('https://www.youtube.com/embed/5gMMbAl_z6U')}
                                                className="poster-audios-card"
                                                src='https://ricardosalinas.com/video/fiat-fraud2.jpg'
                                            />
                                            <div className="poster-audios-card-cintillo">
                                                <h5 onClick={() => openModalVideo('https://www.youtube.com/embed/5gMMbAl_z6U')}>
                                                    {t('videos.vid2')}
                                                </h5>
                                            </div>
                                            <button onClick={() => openModalVideo('https://www.youtube.com/embed/5gMMbAl_z6U')}>
                                                <img src={play} />
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="audios_card">
                                        <div className="audios_card_img">
                                            <img src={bitcoin} />
                                        </div>
                                        <div className="audios_card_content">
                                            <img
                                                onClick={() => openModalVideo('https://www.youtube.com/embed/PYs-xQ8s1CQ')}
                                                className="poster-audios-card"
                                                src='https://ricardosalinas.com/video/bitcoin-maxres3.jpg'
                                            />
                                            <div className="poster-audios-card-cintillo">
                                                <h5 onClick={() => openModalVideo('https://www.youtube.com/embed/PYs-xQ8s1CQ')}>
                                                    {t('videos.vid1')}
                                                </h5>
                                            </div>
                                            <button onClick={() => openModalVideo('https://www.youtube.com/embed/PYs-xQ8s1CQ')}>
                                                <img src={play} />
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="audios_card">
                                        <div className="audios_card_img">
                                            <img src={bitcoin} />
                                        </div>
                                        <div className="audios_card_content">
                                            <img
                                                onClick={() => openModalVideo('https://www.youtube.com/embed/VGwUjGyH5aU')}
                                                className="poster-audios-card"
                                                src={img4}
                                            />
                                            <div className="poster-audios-card-cintillo">
                                                <h5 onClick={() => openModalVideo('https://www.youtube.com/embed/VGwUjGyH5aU')}>
                                                    {t('registro.vid4')}
                                                </h5>
                                            </div>
                                            <button onClick={() => openModalVideo('https://www.youtube.com/embed/VGwUjGyH5aU')}>
                                                <img src={play} />
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="audios_card">
                                        <div className="audios_card_img">
                                            <img src={bitcoin} />
                                        </div>
                                        <div className="audios_card_content">
                                            <img
                                                onClick={() => openModalVideo('https://www.youtube.com/embed/9Bgvq4lDs4k')}
                                                className="poster-audios-card"
                                                src={img3}
                                            />
                                            <div className="poster-audios-card-cintillo">
                                                <h5 onClick={() => openModalVideo('https://www.youtube.com/embed/9Bgvq4lDs4k')}>
                                                    {t('registro.vid3')}
                                                </h5>
                                            </div>
                                            <button onClick={() => openModalVideo('https://www.youtube.com/embed/9Bgvq4lDs4k')}>
                                                <img src={play} />
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="audios_card">
                                        <div className="audios_card_img">
                                            <img src={bitcoin} />
                                        </div>
                                        <div className="audios_card_content">
                                            <img
                                                onClick={() => openModalVideo('https://www.youtube.com/embed/MVV_15VOJL8')}
                                                className="poster-audios-card"
                                                src={img1}
                                            />
                                            <div className="poster-audios-card-cintillo">
                                                <h5 onClick={() => openModalVideo('https://www.youtube.com/embed/MVV_15VOJL8')}>
                                                    {t('registro.vid1')}
                                                </h5>
                                            </div>
                                            <button onClick={() => openModalVideo('https://www.youtube.com/embed/MVV_15VOJL8')}>
                                                <img src={play} />
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="audios_card">
                                        <div className="audios_card_img">
                                            <img src={bitcoin} />
                                        </div>
                                        <div className="audios_card_content">
                                            <img
                                                onClick={() => openModalVideo('https://www.youtube.com/embed/yzN3FQI1MRk')}
                                                className="poster-audios-card"
                                                src={img2}
                                            />
                                            <div className="poster-audios-card-cintillo">
                                                <h5 onClick={() => openModalVideo('https://www.youtube.com/embed/yzN3FQI1MRk')}>
                                                    {t('registro.vid2')}
                                                </h5>
                                            </div>
                                            <button onClick={() => openModalVideo('https://www.youtube.com/embed/yzN3FQI1MRk')}>
                                                <img src={play} />
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>


                            </Swiper>
                            <div className='swiper-controles-registro'>
                                <div className="swiper-button-prev-vertical"><FaChevronUp /></div>
                                <div className="swiper-button-next-vertical"><FaChevronDown /></div>
                            </div>
                            {/*<div class='audios_card'>
                                <div class='audios_card_img'>
                                    <img src={bitcoin}></img>
                                </div>
                                <div class='audios_card_content'>
                                    <h5>Ricardo y el Bitcoin</h5>
                                    <img src={play}></img>
                                    <hr></hr>
                                </div>

                            </div> */}
                        </div>
                    </div>
                </div>
                <img class="landing_bitcoin_registro_img_i" src={back_i}></img>
                <img class="landing_bitcoin_registro_img_d" src={back_d}></img>
                <ModalVideo
                    isOpen={isOpenModalVideo}
                    closeModal={closeModalVideo}
                    urlVideo={urlVideo}
                />
            </div>
        </>
    )
}

export default Registro